export const QA_NAME_APPLICANT_NOTES_BLOCK = 'applicantNotesBlock'

export const QA_NAME_APPLICANT_PROFILE_NOTE = 'applicantProfileNote'

export const QA_NAME_APPLICANT_PROFILE_NOTE_CELL = 'applicantProfileNoteCell'

export const QA_NAME_APPLICANT_PROFILE_NOTE_EDIT = 'applicantProfileNoteEditBtn'

export const QA_NAME_APPLICANT_PROFILE_NOTE_INPUT = 'applicantProfileNoteInput'

export const APPLICANT_PROFILE_NOTE_CLAMP_LINES = 3
